import * as t from './actionTypes';

const initialState = { rewards: [], settings: {}, totalPoints: 0, totalRedemptions: 0, allUserInfo: [] };
const rewardReducer = (state = initialState, action) => {
  switch (action.type) {
    case t.REWARD_LOAD_SUCCESS:
      let rewards = action.rewards;
      var rewardsArr = [];
      if (rewards) {
        const keys = Object.keys(rewards);
        for (var k = 0; k < keys.length; ++k) {
          rewardsArr.push(rewards[keys[k]]);
        }
      }
      state = Object.assign({}, state, { rewards: rewardsArr });
      return state;

    case t.REWARD_CREATE_SUCCESS:
      return state;

    case t.GET_USER_DATA:
      let data = action.data;
      state = Object.assign( {}, state, {
        totalPoints: data.totalPoints,
        totalRedemptions: data.totalRedemptions,
        allUserInfo: data.allUserInfo
      });
      return state;

    case t.SETTINGS_LOAD_SUCCESS:
      return {...state, settings: action.settings};

    default:
      return state;
  }
};

export default rewardReducer;
